import React, { useEffect, useRef, useState } from 'react';
import avatar from './profile_avatar.svg';
import uploadPhoto from './upload_photo.svg';
import classNames from 'classnames';
import './ProfileImageSettingsRow.scss';
import { autoId } from '@workday/upc-common';
import { USER_IMAGE_URL, useUploadProfileImageMutation } from '../../../../slices/account-api.slice';

export const USER_PROFILE_PHOTO_ALT = 'User Profile';

export function ProfileImageSettingsRow() {
    const profileImageUrl = USER_IMAGE_URL;

    const [uploadProfileImage, { isSuccess }] = useUploadProfileImageMutation();

    const formRef = useRef<HTMLFormElement | null>(null);
    const inputFileRef = useRef<HTMLInputElement | null>(null);
    const [imageUrl, setImageUrl] = useState(profileImageUrl);

    useEffect(() => {
        if (isSuccess && formRef.current) {
            setImageUrl(profileImageUrl + '?' + new Date().getTime());
            // clear the form content so that selecting another image will trigger onChange
            formRef.current.reset();
        }
    }, [profileImageUrl, isSuccess]);

    const openFilePicker = e => {
        e.preventDefault();
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    };

    const pickedFile = () => {
        if (formRef.current) {
            const formData = new FormData(formRef.current);
            uploadProfileImage({ formData });
        }
    };

    const onImageError = () => {
        setImageUrl(avatar);
    };

    const imageLoaded = imageUrl.startsWith(profileImageUrl);
    const imageLoadedClassName = 'profileImageSettingsRow__profileImageLoaded';

    return (
        <div className='profileImageSettingsRow'>
            <span className='profileImageSettingsRow__profileImageContainer'>
                <img
                    {...autoId('profileImage')}
                    src={imageUrl}
                    alt={USER_PROFILE_PHOTO_ALT}
                    className={classNames('profileImageSettingsRow__profileImage', {
                        [imageLoadedClassName]: imageLoaded
                    })}
                    onError={onImageError}
                />
                <button onClick={openFilePicker} type='button' className='profileImageSettingsRow__uploadPhotoButton'>
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                    <img src={uploadPhoto} alt='Upload Photo' className='profileImageSettingsRow__uploadPhotoImage' />
                </button>
            </span>
            <form ref={formRef} action={profileImageUrl} method='post' autoComplete='off' encType='multipart/form-data'>
                <input
                    {...autoId('filePicker')}
                    ref={inputFileRef}
                    type='file'
                    name='image'
                    accept='image/jpeg'
                    className='profileImageSettingsRow__filePicker'
                    onChange={pickedFile}
                />
            </form>
        </div>
    );
}
